import {EventApi} from '@fullcalendar/core';
import moment from 'moment/moment';
import {toISODateString} from 'webapp-lib/utils';

import {sum} from '_/utilities';

export const todayISODateString = (): string => toISODateString(moment());

export const toSeconds = (minutes: number): number => minutes * 60;
export const toMinutes = (seconds: number): number => seconds / 60;

export const getEventDurationInHours = (date: EventApi): number =>
  getEventDuration(date, 'hours');

export const getEventDuration = (
  date: EventApi,
  unit: moment.unitOfTime.Diff
): number => {
  const start = moment(date.start);
  const end = moment(date.end);

  return end.diff(start, unit, true);
};

export const getTotalEventDurationInHours = (dates: EventApi[]): number =>
  dates.map(getEventDurationInHours).reduce(sum, 0);
